module.exports = __webpack_public_path__ + "static/media/orchestra_w_700.b49eb18a.jpg";